import React from 'react';
import styled from 'styled-components';
import { FajitaFormHeader, ReadOnlyForm } from '@mummssoftware/common-ui';
import { questionnaire } from '../../context';

export const FormDiv = styled.div`
  margin: 10px;
  margin-left: 5px;
  padding: 5px;
  color: ${(props) => props.theme.palette.primary.main};
  border: 1px solid;
  @media print {
    border: 1px solid black;
  }
`;

type FajitaFormsProps = {
  forms: questionnaire[];
};

export const FajitaForms = ({ forms }: FajitaFormsProps) => (
  <div>
    {forms.map((form: any) => {
      const hasHtml = form.form;
      const hasNotes = hasHtml && form.form.note;
      return (
        <div key={form.q_id}>
          <FajitaFormHeader formData={form} />
          <FormDiv key={form.q_id}>
            <ReadOnlyForm
              key={form.q_id}
              formData={hasHtml ? form.form.fajita : ''}
            />
          </FormDiv>
          {hasNotes && (
            <div dangerouslySetInnerHTML={{ __html: form.form.note }} />
          )}
        </div>
      );
    })}
  </div>
);
